import Lablist from "./Lablist";
export default Lablist;
